<template>
  <div :class="$style.kioskMenuPage">
    <div :class="$style.kioskMenuMain">
      <div :class="$style.kioskMenuHeader">
        <div
          :class="$style.menuHeaderArrow"
          @click="handleStartOver"
        >
          <svg
            v-svg
            :class="$style.curvedArrowUp"
            symbol="kiosk-curved-arrow"
          />
          <h5 :class="$style.menuHeaderTitle">Start Over</h5>
        </div>

        <div :class="$style.menuHeaderArrow">
          <svg
            v-svg
            :class="$style.curvedArrowUp"
            symbol="kiosk-curved-arrow"
          />
          <h5 :class="$style.menuHeaderTitle">View your order</h5>
        </div>
      </div>

      <div :class="$style.kioskMenuWrapper"><DesktopMenu /></div>
    </div>
    <div :class="$style.kioskMenuFooter"><KioskTryBlock /></div>

    <LoadingSpinner
      v-if="menuIsLoading"
      fixed
    />
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import DesktopMenu from '@/apps/desktop/components/DesktopMenu';
import KioskTryBlock from '@/components/KioskTryBlock';
import KioskCartIcon from '@/components/KioskCartIcon';
import { Action, Getter } from 'vuex-class';
import { CART_DISPLAY } from '@/apps/cart/store/types';
import { MODAL_UPDATE } from '@/apps/core/store/types';
import LoadMenuMixin from '@/lib/mixins/load-menu-mixin';
import LoadingSpinner from '@/apps/configurator/components/LoadingSpinner';

/**
 * Provides view to the menu page
 */
@Component({
  components: {
    LoadingSpinner,
    DesktopMenu,
    KioskTryBlock,
    KioskCartIcon,
  },
  mixins: [
    LoadMenuMixin,
  ],
})
export default class KioskMenu extends Vue {
  @Action(CART_DISPLAY) cartDisplay;
  @Action(MODAL_UPDATE) modalUpdate;
  @Getter isKioskPlatform;
  /**
   * Handle "Start Over" event
   */
  handleStartOver() {
    if (this.isKioskPlatform) {
      this.cartDisplay(false);
    }

    this.modalUpdate({
      name: 'cartOrderCancel',
      data: true,
    });
  }
}
</script>

<style lang="scss" module>
@import '~@/style/variables.scss';
.kioskMenuPage {
  display: flex;
  flex-direction: column;
  height: calc(100vh - #{$kioskHeaderHeight});
  min-height: calc(1920px - #{$kioskHeaderHeight});
  flex: 1 1 0;
  position: relative;
}
.kioskMenuMain {
  flex: 1 1 0;
  background-color: $white;
}
.kioskMenuFooter {
  color: red;
}
.kioskMenuHeader {
  display: flex;
  justify-content: space-between;
  padding: 24px 26px 0;
}
.exitBtn {
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-top: 10px;
  outline: none;
  .exitIcon {
    stroke: $black;
    width: 46px;
    height: 50px;
  }
}

.menuHeaderArrow {
  text-align: right;
  margin-top: 16px;
  &:hover {
    cursor: pointer;
  }
  .curvedArrowUp {
    margin-right: 24px;
  }
  .menuHeaderTitle {
    margin-top: 16px;
  }
}

.menuHeaderArrow {
  .menuHeaderTitle {
    margin-top: 20px;
    font-family: 'LP Bambus', sans-serif;
    font-size: 45px;
    font-weight: 400;
  }
  &:first-child {
    margin-top: 24px;
    .curvedArrowUp {
      transform: rotateY(180deg);
      margin-left: 24px;
    }
  }
}
.curvedArrowUp {
  width: 30px;
  height: 36px;
}

.kioskMenuWrapper {
  margin-top: -60px;
}
</style>



// WEBPACK FOOTER //
// src/apps/kiosk/components/KioskMenu.vue